module.exports = __webpack_public_path__ + "static/media/youtube-stream-url.9005272d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dashboard/youtube-stream-url.jpg
// module id = 1276
// module chunks = 0